import { fetchAllPaginated } from 'utils/exportPagination';

/** BE list endpoint returns `{ invoiceData, total }` — normalize for shared export pagination. */
export const normalizeInvoiceListExportPage = (response) => ({
  data: Array.isArray(response?.invoiceData) ? response.invoiceData : [],
  total: response?.total,
});

export const mapInvoiceListSortOptionsForApi = (sortOptions) => {
  if (!sortOptions?.invoice_id) return sortOptions;
  const { invoice_id: invoiceIdDirection, ...rest } = sortOptions;
  return { ...rest, doc_number: invoiceIdDirection };
};

export async function fetchInvoiceListForExport({ filter, sortOptions, totalRecords, fetchList }) {
  if (typeof fetchList !== 'function') {
    throw new Error('fetchList is required for invoice export.');
  }

  const apiSortOptions = mapInvoiceListSortOptionsForApi(sortOptions);
  return fetchAllPaginated({
    totalRecords,
    fetchPage: async ({ offset, limit }) =>
      normalizeInvoiceListExportPage(
        await fetchList({
          filter,
          offset,
          limit,
          sortOptions: apiSortOptions,
        }),
      ),
  });
}
